import { atom } from "jotai";
import { getActivities, getConstructionProgress, getProjectList } from "../../services/dashboard/index";
import { getInstallStatsDownloadReport, getInstallStatsReport, getSummaryData } from "../../services/reports/index";


const reportsAtoms = atom({
    constructionList: {},
    progressList: [],
    summaryData: [],
    statsData: [],
});

export const getActivity = atom(null, async (_, set, _args) => {
    const res = await getActivities()
    if (res) {
        set(reportsAtoms, (prev) => ({ ...prev, constructionList: res.data }));
    }
});


export const getConstructionProgressList = atom(null, async (_, set, _args) => {
    const res = await getConstructionProgress();
    if (res) {
        set(reportsAtoms, (prev) => ({ ...prev, progressList: res.data }));
    }
});


export const fetchSummaryList = atom(null, async (_, set, args) => {
    const res = await getSummaryData(args);
    if (res) {
        set(reportsAtoms, (prev) => ({ ...prev, summaryData: res.data }));
    }
});
export const fetchInstallStatsReportAtom = atom(
    null,
    async (get, set, args) => {
        const res = await getInstallStatsReport(args)
        if (res) {
            set(reportsAtoms, (prev) => ({ ...prev, statsData: res.data }));
        }
    }
);
export const fetchInstallStatsDownloadReportAtom = atom(
    null,
    async (get, set) => {
        set(reportsAtoms, (prev) => ({ ...prev, downloadLoading: true }));
        try {
            const response = await getInstallStatsDownloadReport()
            const projectData = await getProjectList()
            const project = projectData.data.find(p => p.id === parseInt(localStorage.getItem("project_id")));
            
            const csv = response.data;
            const element = document.createElement("a");
            const file = new Blob([csv], { type: 'text/csv' });
            element.href = URL.createObjectURL(file);
            element.download = `${project?.project_number}_Installed_Stats_${project?.name}`;
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
            
          //  toast.success("Download completed");
        } catch (error) {
            console.error(error);
            //toast.error("Download failed");
        } 
    }
);

export default reportsAtoms;
